/**
 * Получение пакетов телеканалов, по нему сможем определить
 * какие каналы входят в определенный пакет
 * @param {number | string | number[]} freePackets Пакеты каналов
 * @returns {Function}
 */
interface IPackages {
    packages: string[];
}

export function getChannelPackages (freePackets: number | string | number[]): IPackages {
    if (!freePackets) {
        return;
    }

    const packagesIds = Array.isArray(freePackets)
        ? freePackets.map(String)
        : String(freePackets).split(',');

    return (
        {
            packages: [...new Set(packagesIds)],
        }
    );
}
